import React from 'react';
import Config from 'config';
import { updatePageTrackDigitalData } from './digital-data';

export const asyncComponent = (loadComponent, namedExport) =>
  class AsyncComponent extends React.Component {
    state = {
      Component: null,
    };

    componentWillMount() {
      this.unlisten = this.props.history.listen((location, _action) => {
        updatePageTrackDigitalData(`${Config.api.host}${location.pathname}`)
      });
    }

    componentDidMount() {
      loadComponent().then(componentModule => {
        updatePageTrackDigitalData(`${Config.api.host}${this.props.location.pathname}`);
        const module = componentModule.default || componentModule[namedExport];
        this.setState({ Component: module });
      });
    }

    componentWillUnmount() {
      this.unlisten();
    }

    render() {
      const { Component } = this.state;
      return Component && <Component {...this.props} />;
    }
  };
